import {AdminbarUI, createAdminbarInstances} from "./adminbarUI";

class Adminbar {
    public constructor(private ui: AdminbarUI) {
        this.ui.onCloseButtonClick(this.handleCloseButtonClick.bind(this));
    }

    private handleCloseButtonClick() {
        this.ui.destroy();
    }
}

export function initAdminbar() {
    const instances = createAdminbarInstances();
    instances.map((ui: AdminbarUI) => {
        return new Adminbar(ui);
    })
}